//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RemittanceType } from './Enums';

export class RemittanceOrRefundInputItem extends ItemBase {
    RemittanceType: RemittanceType = RemittanceType.Remittance;
    Amount: number = 0;
    CashCategoryID: string | null = null;
    Payee: string | null = null;
    Date: string = "1970-01-01T00:00:00";
    Description: string | null = null;
    PaymentMethod: string | null = null;
    TaxDefinitionID: string | null = null;

    constructor(initializer?: Partial<RemittanceOrRefundInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "RemittanceOrRefundInputItem";
}
